import Crud from './crud'
var crud = new Crud('fee_weights', 'phí cân');

const state = {
    ...crud.state,
    selected: {"ID":0,"UID":0,"StorageID":0,"ProductType":0,"ValueMin":0,"ValueMax":0,"Amount":0}
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};